import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { GameTransactionsService } from 'src/app/services/game-transactions/game-transactions.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
    selector: 'app-game-transactions',
    templateUrl: './game-transactions.component.html',
    styleUrls: ['./game-transactions.component.scss'],
})
export class GameTransactionsComponent implements OnInit {

    @ViewChild(IonContent, { static: false }) content: IonContent;

    public emailMeDisabled = true;
    public searchDisabled = false;
    public showNoResults = false;
    public showTable = false;

    public toDate;
    public fromDate;
    public todayDate = '2018-01-01';
    public showFrom = false;
    public showTo = false;

    public transfers: any[];
    public totalRecords: number = 0;
    public currentPage: number = 1;
    public maxPage: number = 1;
    public error: any = null;

    public startDate: any;
    dateRange: number;
    public PIPE_DATE_FORMAT = !!this.config.getConfig().FEATURE_TIME_FORMAT ? this.config.getConfig().FEATURE_TIME_FORMAT : 'MM-dd-yyyy'; //MM-dd-yyyy, hh:mm a' Use this for Full date
    public PIPE_DATE_FORMAT_WITH_TIME_STAMP = !!this.config.getConfig().FEATURE_TIME_FORMAT_TIME_STAMP ? this.config.getConfig().FEATURE_TIME_FORMAT_TIME_STAMP : 'MM-dd-yyyy, hh:mm a';
    
    constructor(public navCtrl: Navigator,
        public navParams: NavParams,
        public successMessageProvider: SuccessMessageService,
        private gameTransactionsService: GameTransactionsService,
        public config: ConfigService,
        private timeService: TimeService) {
     }
    
    ngOnInit(): void {
        this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
    }

    calendarUpdate(event) {
        this.toDate = event.toDate;
        this.fromDate = event.fromDate;
        this.searchDisabled = event.search;
        this.successMessageProvider.clearMessage();
    }
        
    ionViewDidEnter() {
        this.successMessageProvider.clearMessage();
        
        let today = new Date();
        let date = new Date();
 
        this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
        this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today)); //setting today date fallback and initial value for 'To' data passed to webservices
        this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
    }
        
    onSearch() {
        this.searchDisabled = true;
        this.showTable = false;
        this.currentPage = 1;

        this.error = null;

        this.getTransfers();
    }

    onPageChange(event) {

        this.currentPage = event;

        this.getTransfers();
    }

    getTransfers() {
        this.successMessageProvider.clearMessage();

        this.showNoResults = false;
        this.showTable = false;

        this.error = null;
        this.gameTransactionsService.callGetTransfers(this.fromDate, this.toDate, this.currentPage).subscribe(
            (response) => {

                if (response.result == 1) {
                    this.transfers = response.payload.response;//.reverse();
                    this.totalRecords = response.payload.count;
                    this.currentPage = response.payload.current_page;
                    this.maxPage = response.payload.pages;

                    if (this.totalRecords > 0) {
                        this.showTable = true;
                        this.showNoResults = false;
                    }
                    else {
                        this.showNoResults = true;
                        this.showTable = false;
                    }

                    this.emailMeDisabled = false;
                    // TODO figure out this scroll
                    // this.content.scrollTo(0, 345, 1000)
                }
            }
        )
    }

    onEmailMeClicked() {

        this.emailMeDisabled = true;

        this.error = null;

        this.gameTransactionsService.callSendTransfers(this.fromDate, this.toDate).subscribe(
            (response) => {

                if (response.result == 1) {
                    this.content.scrollToTop(10);

                    this.successMessageProvider.setMessage("An email with all results has been sent.");
                }
            },
            (error) => {

                this.successMessageProvider.clearMessage();

                this.error = error;
                this.emailMeDisabled = false;
                this.content.scrollToTop(10);
            }
        )
    }
}
